import { FC, useState } from "react";
import styles from "../Creator/Creator.module.css";
import ShowCards from "../../components/Cards/ShowCards/ShowCards";
import ShowBoosters from "../../components/Boosters/ShowBoosters/ShowBoosters";
import globalStyles from "../../styles/globalStyles.module.css";
import InfiniteScroll from "../../components/InfiniteScroll/InfiniteScroll";
import { useCollectorCardsContext } from "../../context/Collector/CollectorCardsProvider";
import { useCollectorBoostersContext } from "../../context/Collector/CollectorBoostersProvider";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FilterBoosters from "../../components/Boosters/FilterBoosters/FilterBoosters";

export enum CollectionViewMode {
  cards = 1,
  boosters = 2,
}

interface CollectionProps {
  viewModeValue?: CollectionViewMode;
}

const Collection: FC<CollectionProps> = ({
  viewModeValue = CollectionViewMode.boosters,
}) => {
  const [viewMode, setViewMode] = useState(viewModeValue.valueOf()); // Default selected value
  const { cardsState } = useCollectorCardsContext();
  const { t } = useTranslation();

  const collectorBoosterContext = useCollectorBoostersContext();

  const radios = [
    { name: t("cards.label"), value: 1, page: "cards" },
    { name: t("boosters.label"), value: 2, page: "boosters" },
  ];

  const contentMap: { [key: number]: JSX.Element } = {
    1: (
      <InfiniteScroll
        key={1}
        togglePage={cardsState.togglePage}
        loading={cardsState.loading}
        hasMore={cardsState.hasMore}
      >
        {/* <FilterCards
          cards={cardsState.data}
          handleFilterCards={cardsState.setFilteredData}
        /> */}
        {cardsState.filteredData.length === 0 ? (
          <div className={globalStyles.center}>{t("noContent")}</div>
        ) : (
          <ShowCards cards={cardsState.filteredData} />
        )}
      </InfiniteScroll>
    ),
    2: (
      <InfiniteScroll
        key={2}
        togglePage={collectorBoosterContext.boostersState.togglePage}
        loading={collectorBoosterContext.boostersState.loading}
        hasMore={collectorBoosterContext.boostersState.hasMore}
      >
        <FilterBoosters
          boosters={collectorBoosterContext.boostersState.data}
          handleFilterBoosters={
            collectorBoosterContext.boostersState.setFilteredData
          }
        />
        {collectorBoosterContext.boostersState.data.length === 0 ? (
          <div className={globalStyles.center}>{t("noContent")}</div>
        ) : (
          <ShowBoosters
            boosters={collectorBoosterContext.boostersState.filteredData}
          />
        )}
      </InfiniteScroll>
    ),
  };

  return (
    <div>
      <div className={globalStyles.pageTitle}>{t("collection.label")}</div>
      <div className={styles.buttonGroup}>
        {radios.map((radio, index) => (
          <Link
            to={`/collection/${radio.page}`}
            className={styles.none}
            key={index}
          >
            <div
              key={index}
              className={`${styles.toggleButton} ${
                radio.value === viewMode ? styles.active : ""
              }`}
              onClick={() => setViewMode(radio.value)}
            >
              {radio.name}
            </div>
          </Link>
        ))}
      </div>
      <div>{contentMap[viewMode]}</div>
    </div>
  );
};

export default Collection;
